// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsvideoconfig = {
    "awsInputVideo": "clixstreamvod-dev-input-u5gvmhr5",
    "awsOutputVideo": "clixstreamvod-dev-output-u5gvmhr5.s3.eu-west-1.amazonaws.com"
};

export default awsvideoconfig;